<template>
  <Codemirror
    ref="codemirrorRef"
    v-bind="$attrs"
    v-model:value="newValue"
    :options="options"
    :placeholder="placeholder"
    :border="border"
    :width="width"
    :height="height"
    :original-style="originalStyle"
    :keep-cursor-in-end="KeepCursorInEnd"
    :merge="merge"
    @change="onChange"
    @blur="onBlur"
    @focus="onFocus"
    @scroll="onScroll"
    @keyup="onKeyup"
  />
</template>
<script lang="ts" setup>
import { computed, ref } from 'vue'

import {
  codemirrorEditorVue3Emits,
  codemirrorEditorVue3Props,
} from './codemirror-editor-vue3'

import Codemirror from 'codemirror-editor-vue3'

// 1.defineOptions
defineOptions({
  name: 'LlCodemirrorEditorVue3',
})

// 2.props
const props = defineProps(codemirrorEditorVue3Props)
const emits = defineEmits(codemirrorEditorVue3Emits)

const codemirrorRef = ref()
const newValue = computed({
  get() {
    return props.value
  },
  set(v) {
    emits('update:value', v)
  },
})

const onChange = (v) => {
  emits('change', v)
}
const onBlur = (codeMirror, e) => {
  emits('blur', codeMirror, e)
}
const onFocus = (codeMirror, e) => {
  emits('focus', codeMirror, e)
}
const onScroll = (codeMirror) => {
  emits('scroll', codeMirror)
}
const onKeyup = (codeMirror, e) => {
  emits('keyup', codeMirror, e)
}

// 暴露的方法
const codemirrorExpose = {
  cminstance() {
    return codemirrorRef.value?.cminstance
  },
  destroy() {
    return codemirrorRef.value?.destroy()
  },
  refresh() {
    return codemirrorRef.value?.refresh()
  },
  resize() {
    return codemirrorRef.value?.resize()
  },
}
defineExpose(codemirrorExpose)
</script>
